import { computed, inject, Injectable, signal } from '@angular/core';
import { Platform } from '@ionic/angular/standalone';

@Injectable({
  providedIn: 'root',
})
export class ScreenResizeService {
  private platform = inject(Platform);
  readonly isNative = signal(this.platform.is('capacitor'));

  readonly screenWidth = signal(window.innerWidth);

  readonly isDesktop = computed(() => {
    return this.screenWidth() >= 768 && !this.isNative();
  });

  readonly isMobile = computed(() => {
    return this.screenWidth() < 768 || this.isNative();
  });
}
